import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  endClientSession,
  getStoredUser,
  hasActiveSession,
  purgeOrphanedPersonalData,
  setSession,
} from "../../logic/util/session";

interface UserData {
  id: string;
  first: string;
  last: string;
  email: string;
  platform: any;
}

interface AuthState {
  user: UserData | null;
}

interface LoginPayload {
  token: string;
  userData: UserData;
}

purgeOrphanedPersonalData();

const initialState: AuthState = {
  user: hasActiveSession() ? getStoredUser<UserData>() : null,
};

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    login: (state, action: PayloadAction<LoginPayload>) => {
      setSession(action.payload.token, action.payload.userData);
      state.user = { ...action.payload.userData };
    },
    logout: (state) => {
      state.user = null;
      endClientSession("/login");
    },
    updateUserData: (state, action) => {
      state.user = { ...action.payload };
    },
    checkAuthentication: (state) => {
      if (hasActiveSession()) {
        state.user = getStoredUser<UserData>();
      } else {
        purgeOrphanedPersonalData();
        state.user = null;
      }
    },
  },
});

export const { login, logout, updateUserData, checkAuthentication } =
  authSlice.actions;

export default authSlice.reducer;
